/**
 * Module: `utils.ts` — client library utilities.
 * @remarks See exports; keep imports from concrete files when possible.
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Converts seconds to milliseconds (for timeouts, delays, etc.). */
export function secondsTOms(seconds: number): number {
  return 1000 * seconds;
}

/** Converts minutes to milliseconds (for staleTime, gcTime, etc.). */
export function minutesTOms(minutes: number): number {
  return 1000 * 60 * minutes;
}

/** Converts hours to milliseconds (for long-lived cache, etc.). */
export function hoursTOms(hours: number): number {
  return 1000 * 60 * 60 * hours;
}
